import React from 'react'
import clsx from 'clsx'

import FormControlLabel from '@material-ui/core/FormControlLabel'
import Checkbox from '.'

import useStyles from './useStyles'

export interface CheckBoxInputProps {
  checked?: boolean
  disabled?: boolean
  isCard?: boolean
  className?: string
  name?: string
  label?: string
  value?: string
  onChange?: (
    event: React.ChangeEvent<HTMLInputElement> | React.ChangeEvent<any>,
  ) => void | Promise<void>
}

const CheckBoxInput: React.FC<CheckBoxInputProps> = ({
  checked,
  disabled,
  isCard,
  className,
  name,
  label,
  value,
  onChange,
}) => {
  const classes = useStyles()

  return (
    <FormControlLabel
      className={clsx(
        classes.root,
        disabled && classes.disabled,
        checked && classes.checked,
        isCard && classes.isCard,
        className,
      )}
      label={label}
      labelPlacement="end"
      control={
        <Checkbox
          name={name}
          disableRipple
          disabled={disabled}
          defaultChecked={checked}
        />
      }
      value={value}
      onChange={onChange}
    />
  )
}

export default CheckBoxInput
